// Module
var code = `<wizard ng-if="\$ctrl.views.length > 0" views="\$ctrl.views" on-complete="\$ctrl.onComplete()"></wizard>`;
// Exports
export default code;